module.exports = __webpack_public_path__ + "static/media/icon-manager.84552e39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icon-manager.svg
// module id = 1086
// module chunks = 0